// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".online-tab-header[data-v-2f13f526] {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n}\n.online-tab-header .translation-button[data-v-2f13f526] {\n  margin-bottom: 20px;\n}\n.online-tab-header .translation-button .translation-icon[data-v-2f13f526] {\n  margin-right: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
